import { CreateRoute } from "../../CreateRouter";
import { serviceRoutes } from "./routes";

export const ServiceRouter = () => CreateRoute(serviceRoutes);
